import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { useNoScroll, usePolling } from "common/hooks";

import { FETCH_REPORT_NOTIFICATIONS } from "common/actions/reports_notifications";

import { AlertsPopup } from "./alerts_popup";
import { AnnouncementsPopup } from "./announcements_popup";
import { DownloadsPopup } from "./downloads_popup";
import { ReportsPopup } from "./reports_popup";
import { TutorialsPopup } from "./tutorials_popup";
import { MimicPopup } from "./mimic_popup";

export function IconBar() {
    const hasPackagedReports = useSelector((state) => state.common.user_permissions.feature_packaged_reports);
    const [panelVisible, setPanelVisible] = useState(false);
    const dispatch = useDispatch();
    
    const fetch_report_notifications = useCallback(() => dispatch(FETCH_REPORT_NOTIFICATIONS()), [dispatch]);

    useNoScroll(panelVisible);
    
    usePolling({ fetch: fetch_report_notifications });
    
    const onVisibilityChange = useCallback((visible, title) => {
        // reactjs-popup is AAF. When you click from one panel to another,
        // the open event for the new panel fires first then close even for the previously opened panel is fired second.
        // To prevent this we will defer onVisibilityChange for the opening and fire close event synchronously.
        // Otherwise the screen will move side-to-side due to useNoScroll effect
        if (visible) {
            setTimeout(() => setPanelVisible(true, title), 100);
        } else {
            setPanelVisible(false, title);
        }
    }, []);
    
    return (
        <IconBarWrapper>
            <AlertsPopup onVisibilityChange={onVisibilityChange} />
            {hasPackagedReports && <ReportsPopup onVisibilityChange={onVisibilityChange} />}
            <DownloadsPopup onVisibilityChange={onVisibilityChange} />
            <AnnouncementsPopup onVisibilityChange={onVisibilityChange} />
            <TutorialsPopup onVisibilityChange={onVisibilityChange} />
            <MimicPopup onVisibilityChange={onVisibilityChange} />
        </IconBarWrapper>
    );
}

const IconBarWrapper = styled.div`
    display: flex;
    padding-top: 6px;
`;
